import { Box, Container } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSettingsContext } from 'src/components/settings';
import { useBoolean } from 'src/hooks/use-boolean';
import { useGetShopFloorBuildsQuery } from 'src/store/Reducer/shop-floor-display-settings';
import { SHOP_FLOOR_AUTO_REFRESH_MS } from '../display-links/floor-display-config';
import FloorDisplayHeader from '../display-links/floor-display-header';
import TableLink from '../display-links/table-link';
import PasscodeView from './passcode-view';
import { subscribeUnreadCount } from 'src/utils/socket';


const ShopFloorDisplayLinkView = () => {

  const settings = useSettingsContext();


  const [now, setNow] = useState(new Date());

  const [lastUpdatedAt, setLastUpdatedAt] = useState(new Date());

  const [openQuestionCount , setOpenQuestionCount] = useState(0);

  const showPasscode = useBoolean(true);

  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');

  const [currentPage, setCurrentPage] = useState(1);

  const { data, isLoading, isFetching, refetch } = useGetShopFloorBuildsQuery(
    { token, page: currentPage , limit : 7 },
    { refetchOnMountOrArgChange: true }
  );

  const { totalPages, refreshInterval } = useMemo(() => {
  return {
    totalPages: data?.metadata?.total_pages ?? 1,
    refreshInterval: (data?.metadata?.auto_refresh_interval ?? 60) * 1000,
  };
}, [data]);

  useEffect(() => {
    if (data?.metadata?.is_verified) {
      showPasscode.onFalse()
    }
  },[data])


  // Cycle pages every refreshInterval. When there's only one page, the page
  // number never changes, so the query args stay identical and RTK Query
  // won't auto-refetch — trigger it manually in that case.
  useEffect(() => {
    const cycleId = setInterval(() => {
      setCurrentPage((prevPage) => {
        const nextPage = totalPages > 1 ? (prevPage % totalPages) + 1 : 1;
        if (nextPage === prevPage) {
          refetch();
        }
        return nextPage;
      });
      setLastUpdatedAt(new Date());
    }, refreshInterval);

    return () => clearInterval(cycleId);
  }, [totalPages, refreshInterval, refetch]);

  useEffect(() => {
    const clockId = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(clockId);
  }, []);


   useEffect(() => {
      let cancelled = false;
      let unsubscribe;
  
      const initialize = async () => {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        if (cancelled) return;
  
        unsubscribe = subscribeUnreadCount((count) => {
          console.log("Listen event unread count for open questions is :", count);
          setOpenQuestionCount(count);
        });
  
      };
  
      initialize();
  
      return () => {
        cancelled = true;
        unsubscribe?.();
      };
    }, []);

console.log(data?.metadata?.unread_count , "data?.metadata?.unread_count")
  useEffect(() => {
    if (data?.metadata?.unread_count !== undefined) {
      setOpenQuestionCount(data?.metadata?.unread_count);
    }
  },[data , data?.metadata?.unread_count]);
  const displayMetrics = useMemo(() => {
    const pastDueCount = data?.metadata?.past_due || 0;
    const activeBuilds = data?.metadata?.active || 0;
    const openQuestionCount = data?.metadata?.unread_count || 0;

    return {
      totalBuilds: activeBuilds,
      pastDueCount,
      openQuestionCount: openQuestionCount,
    };
  }, [data]);
  return (
    <>
      {showPasscode.value ?
        <Box sx={{ maxWidth: "500px", mx: "auto", my: "auto" }} >
          <PasscodeView onFalse={showPasscode.onFalse} />
        </Box >
        : <Box
          sx={{
            minHeight: '100vh',
            bgcolor: '#eaf1fb',
            backgroundImage:
              'radial-gradient(circle at top left, rgba(77, 102, 204, 0.14), transparent 28%), linear-gradient(180deg, #f8fbff 0%, #edf4ff 48%, #e6eef9 100%)',
            py: { xs: 2, md: 3 },
          }}
        >
          <Container maxWidth={settings.themeStretch ? false : 'xl'}>
            <Box
              sx={{
                px: { md: 4 },
              }}
            >
              <FloorDisplayHeader
                now={now}
                lastUpdatedAt={lastUpdatedAt}
                refreshIntervalMs={refreshInterval || SHOP_FLOOR_AUTO_REFRESH_MS}
                totalBuilds={displayMetrics.totalBuilds}
                pastDueCount={displayMetrics.pastDueCount}
                openQuestionCount={displayMetrics.openQuestionCount}
              />

              <TableLink
                title="Active Builds"
                builds={data?.body?.list}
                now={now}
                currentPage={currentPage}
              />
            </Box>
          </Container>
        </Box>
      }
    </>
  );
};

export default ShopFloorDisplayLinkView;
